import styled, { css } from 'styled-components';
import { breakpoint } from '../theme/breakpoint';
import { Card } from '../content-card/styles';

export const CardRow = styled.div`
  display: flex;
  flex-flow: column nowrap;

  ${breakpoint.tablet`
    flex-flow: row wrap;
    justify-content: space-between;
  `};

  ${Card} {
    display: flex;
    &:last-of-type {
      margin-bottom: ${({ theme }) => theme.spacing.standard};
    }

    ${breakpoint.tablet`
      ${({ $items, theme }) =>
        $items &&
        css`
          flex: 0 1;
          flex-basis: calc(
            ${Math.floor(100 / $items)}% - ${theme.spacing.tiny}
          );
          margin-bottom: ${theme.spacing.standard};
        `}
    `};
  }

  // add a bottom margin to (CTA) link immediately following CardRow
  + a {
    margin-bottom: ${({ theme }) => theme.spacing.large};
  }
`;

export const BannerBackground = styled.section`
  margin-bottom: ${({ theme, $sidebar, $removeMarginBottom }) => {
    if ($removeMarginBottom) {
      return '0';
    }
    if ($sidebar) {
      return theme.spacing.standard;
    }
    return theme.spacing.medium;
  }};
  padding: 0;
  /* padding-top: ${({ theme, $sidebar }) =>
    $sidebar ? 0 : theme.spacing.large}; */
  background-color: ${({ $bannerColor, theme }) =>
    ($bannerColor === 'grey' && theme.palette.lightBackground) ||
    ($bannerColor === 'white' && theme.palette.white)};

  ${Card} {
    /* vertical */
    ${({ $bannerFlow }) =>
      $bannerFlow === 'vertical' &&
      css`
        flex: 1 1 100%;
        width: 100%;
        max-width: 600px;
      `}
  }
`;

export const HeaderText = styled.div`
  margin-bottom: ${({ theme }) => theme.spacing.medium};

  h2:first-child {
    margin-top: 0;
  }

  h3:first-child {
    margin-top: 0;
  }

  a {
    text-decoration: none;
  }
`;
